/*=============================================== TruncatePage ===============================================*/

import { Truncate, Tag, Spacers, Radiuses } from "tsx-library-julseb"
import styled from "styled-components/macro"

import { ComponentsLayout } from "components"
import type { ItemType } from "components"

const StyledTruncate = styled(Truncate)`
    max-width: 400px;
    background-color: ${({ theme }) => theme.Gray100};
    padding: ${Spacers.XS};
    border-radius: ${Radiuses.S};
`

const TruncatePage = () => {
    const names: string[] = [
        "Julien",
        "Sile",
        "Max",
        "Maud",
        "Mel",
        "Michael",
        "Yan",
        "Amy",
        "Juliette",
        "Jeff",
    ]

    const items: ItemType[] = [
        {
            title: "",
            intro: "",
            content: (
                <StyledTruncate>
                    {names.map((name, i) => (
                        <Tag key={i}>{name}</Tag>
                    ))}
                </StyledTruncate>
            ),
            // eslint-disable-next-line
            code: 'const StyledTruncate = styled(Truncate)`\n    max-width: 400px;\n    background-color: ${({ theme }) => theme.Gray100};\n    padding: ${Spacers.XS};\n    border-radius: ${Radiuses.S};\n`\n\nconst names = ["Julien", "Sile", "Max", "Maud", "Mel", "Michael", "Yan", "Amy", "Juliette", "Jeff"]\n\n<StyledTruncate>\n    {names.map((name, i) => (\n        <Tag key={i}>{name}</Tag>\n    ))}\n</StyledTruncate>',
            // eslint-disable-next-line
            codeTs: 'const StyledTruncate = styled(Truncate)`\n    max-width: 400px;\n    background-color: ${({ theme }) => theme.Gray100};\n    padding: ${Spacers.XS};\n    border-radius: ${Radiuses.S};\n`\n\nconst names: string[] = ["Julien", "Sile", "Max", "Maud", "Mel", "Michael", "Yan", "Amy", "Juliette", "Jeff"]\n\n<StyledTruncate>\n    {names.map((name, i) => (\n        <Tag key={i}>{name}</Tag>\n    ))}\n</StyledTruncate>',
        },
    ]

    return <ComponentsLayout items={items} propsItems={[]} />
}

export default TruncatePage
